import { useTranslation } from 'react-i18next';

import { StatCard } from '@/shared/ui';

interface LostDamagedStatsCardProps {
  lost?: string;
  damaged?: string;
  isLoading: boolean;
}

export function LostDamagedStatsCard({ lost, damaged, isLoading }: LostDamagedStatsCardProps) {
  const { t } = useTranslation();

  return (
    <StatCard
      label={t(lost === undefined ? 'welcome.chart.numberdamaged.label' : 'welcome.chart.numberlostdamaged.label')}
      value={
        <div className="flex flex-wrap gap-x-3">
          {lost !== undefined && (
            <span>
              {t('welcome.chart.lost.label')} {lost}
            </span>
          )}
          <span>
            {t('welcome.chart.damaged.label')} {damaged}
          </span>
        </div>
      }
      isLoading={isLoading}
    />
  );
}
